module.exports = "/assets/012f381fd49cae822f8bf03d46a7b50d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/P9.png
// module id = 1708
// module chunks = 0